import React from "react";
import { connect } from "react-redux";

import { IAppState } from "../core/state/Store";

import GeneralContainer from "../core/components/containers/GeneralContainer";
import { Alignment, Side, Size } from "../core/types/system/Layout";
import Recommendation from "../core/types/admin/Recommendation";
import Panel from "../core/components/panels/Panel";
import { initialiseRecommendations } from "../core/state/administration/Recommendations";

import "./Recommendations.scss";

interface RouteRecommendationsProps {
    recommendations: Recommendation[];

    initialiseRecommendations: () => void;
}

interface RouteRecommendationsState {
    licenceCode?: string;
}

class RouteRecommendations extends React.Component<
    RouteRecommendationsProps,
    RouteRecommendationsState
> {
    state: RouteRecommendationsState = {};

    componentDidMount(): void {
        this.props.initialiseRecommendations();
    }

    render() {
        return (
            <section>
                <GeneralContainer
                    scaling={true}
                    mid={true}
                    max={true}
                    bufferSide={Side.All}
                    alignment={Alignment.Center}>
                    <Panel
                        bufferSide={Side.All}
                        clearanceSide={Side.Top}
                        clearanceSize={Size.Large}>
                        <ul className="list">
                            {this.props.recommendations.map((item, index) => (
                                <li
                                    key={index}
                                    className={`recommendation flex-row ${
                                        !item.isRecommended ? "done" : ""
                                    }`}>
                                    <div className="flex row-responsive">
                                        <div className="col-pane">
                                            <i
                                                className={`recommendation-icon type${item.severity}`}></i>
                                        </div>
                                        <div className="col-responsive">
                                            <h3 className="truncated inline">
                                                {item.title}
                                            </h3>
                                            <br />
                                            <h4>{item.summary}</h4>
                                            <div
                                                dangerouslySetInnerHTML={{
                                                    __html: item.description,
                                                }}></div>
                                        </div>
                                    </div>
                                </li>
                            ))}
                        </ul>

                        {this.props.recommendations.length === 0 && (
                            <div>You have no recommendations.</div>
                        )}
                    </Panel>
                </GeneralContainer>
            </section>
        );
    }
}

const mapStateToProps = (state: IAppState) => {
    const { recommendations } = state.db;
    return {
        recommendations: recommendations.recommendations,
    };
};

const mapDispatchToProps = dispatch => {
    return {
        initialiseRecommendations: () => dispatch(initialiseRecommendations()),
    };
};

export default connect(mapStateToProps, mapDispatchToProps)(RouteRecommendations);
